import Vue from 'vue';
import events from '../../events/events';
import store from '../../vuex/store';
import router from '../../router';

var shared =
{
    state:
    {
        loaded: false, // component loaded (only once)
        ready: false, // data fetched (every time the location changes)
        
        client: null,
        location: null,
        project: null,

        mousedown: false,
        dragAction: 'select',

        editAction: null,
        pasting: false,

        selection: [],
        selectedCount: 0,
        selectionOffsets: [],

        days: [],
        items: {},

        availability: {},
        preview: null,
        hasPreview: false,

        users: {},
        duties: {},
        shifts: {},
        locations: {},
        tags: {},
        projects: null,

        clients: null,
        comments: [],
        notes: [],

        periods: {},
        period: null,
        from: null,
        until: null,

        weather: {},
        today: '',

        preset: false,

        coordinates: [], // holds the coordinates of the currently displayed items
    },

    getRoster(callback)
    {
        shared.state.ready = false;

        let loadClient = router.currentRoute.params.id;

        // close toolbox in case it's still open
        events.$emit('toolbox.close');

        // get current location if it's not set
        if ( ! store.state.current.location)
        {
            // try to get current active location of user
            store.dispatch('app/reinit', () =>
            {
                shared.state.location = store.state.current.location;

                // still no location? user has no access to any location!
                if ( ! shared.state.location)
                {
                    Vue.onduro.redirect('overview');
                    return;
                }

                // location found! get roster!
                this.getRoster(callback);
            });

            return;
        }

        shared.resetSelection();

        // get roster for location, from, until
        Vue.http.get('/api/items', {
            params: {
                scope: 'planning',
                location: shared.state.location,
                project: shared.state.project,
                period: shared.state.period,
            }})
            .then(response =>
            {
                shared.state.days = response.data.days;
                shared.state.items = response.data.items;
 
                if ( ! shared.state.loaded || loadClient) {
                    // set client explicitly
                    shared.state.client = response.data.client;
                }

                shared.state.users = response.data.users;
                shared.state.duties = _.keyBy(_.sortBy(response.data.duties, (duty) => duty.name.toLowerCase()), 'id');
                shared.state.shifts = _.keyBy(_.sortBy(response.data.shifts, (shift) => shift.name.toLowerCase()), 'id');
                shared.state.locations = _.keyBy(_.sortBy(response.data.locations, (location) => location.name.toLowerCase()), 'id');
                shared.state.comments = response.data.comments;
                shared.state.notes = response.data.notes;
                shared.state.tags = response.data.tags;
                shared.state.availability = response.data.availability;

                shared.state.period = response.data.periods.default;
                shared.state.periods = response.data.periods.options;
                shared.state.from = response.data.periods.from;
                shared.state.until = response.data.periods.until;

                shared.state.preset = false;
                shared.state.loaded = true;
                shared.state.ready = true;

                if (Vue.onduro.hasModule('weather'))
                {
                    shared.state.weather = response.data.weather;
                }

                Vue.http.get('/api/projects?only-active=true').then(response => {
                    shared.state.projects = response.data
                });

                events.$emit('roster.loaded');

                if (typeof callback === 'function') callback();
            })
            .catch(error =>
            {
                if (error.response.status == '409')
                {
                    // try to get current active location of user
                    store.dispatch('app/reinit', () =>
                    {
                        shared.state.location = store.state.current.location;

                        // still no location? user has no access to any location!
                        if ( ! shared.state.location)
                        {
                            Vue.onduro.redirect('overview');
                            return;
                        }

                        // location found! get roster!
                        this.getRoster(callback);
                    });
                }
            });
    },

    getPreset(callback)
    {
        shared.state.ready = false;

        // close toolbox in case it's still open
        events.$emit('toolbox.close');

        // get current location if it's not set
        if ( ! store.state.current.location)
        {
            // try to get current active location of user
            store.dispatch('app/reinit', () =>
            {
                shared.state.location = store.state.current.location;

                // still no location? user has no access to any location!
                if ( ! shared.state.location)
                {
                    Vue.onduro.redirect('overview');
                    return;
                }

                // location found! get roster!
                this.getRoster(callback);
            });

            return;
        }

        shared.resetSelection();

        // get roster for location, from, until
        Vue.http.get('/api/items', {
            params: {
                scope: 'preset',
                location: shared.state.location,
            }})
            .then(response =>
            {
                shared.state.days = response.data.days;
                shared.state.items = response.data.items;
                
                shared.state.comments = response.data.comments;
                shared.state.notes = response.data.notes;
                shared.state.tags = response.data.tags;
                shared.state.availability = response.data.availability;

                shared.state.loaded = true;
                shared.state.ready = true;

                events.$emit('roster.loaded');

                if (typeof callback === 'function') callback();
            })
            .catch(error =>
            {
                if (error.response.status == '409')
                {
                    // try to get current active location of user
                    store.dispatch('app/reinit', () =>
                    {
                        shared.state.location = store.state.current.location;

                        // still no location? user has no access to any location!
                        if ( ! shared.state.location)
                        {
                            Vue.onduro.redirect('overview');
                            return;
                        }

                        // location found! get roster!
                        this.getRoster(callback);
                    });
                }
            });
    },

    getUser(id)
    {
        return shared.state.users[id];
    },

    getDuty(id)
    {
        return shared.state.duties[id];
    },

    getShift(id)
    {
        return shared.state.shifts[id];
    },

    getLocation(id)
    {
        return shared.state.locations[id];
    },

    getClient(id)
    {
        return shared.state.clients ? shared.state.clients[id] : null;
    },

    getTag(id)
    {
        return shared.state.tags[id];
    },

    getComments(id)
    {
        return _.orderBy(shared.state.comments.filter(item =>
        {
            return id === item.date;
        }), ['createdAt'], ['asc']);
    },

    removeComment(id)
    {
        shared.state.comments = _.remove(shared.state.comments, (item) =>
        {
            return item.id !== id;
        });
    },

    hasApplications(item)
    {
        if ( ! item.assigned && item.applications.length)
        {
            Vue.modal.show(Vue.t('text.attention'), Vue.t('warning.item_with_applications'));
            return true;
        }

        return false;
    },

    getNotes(date)
    {
        let note = _.find(shared.state.notes, {date: date});

        return note ? note.content : null;
    },

    resetSelection(hard)
    {
        _.forEach(shared.state.items, item =>
        {
            item.selected = false;
        });

        shared.state.dragAction = 'select';
        shared.state.selectedCount = 0;

        if (hard)
        {
            // hard reset will also
            shared.state.editAction = null;
            shared.state.pasting = false;
            shared.state.selection = [];
            shared.state.selectionOffsets = [];
        }
        else
        {
            // only remove coordination event listeners between
            // location switch or change of month via dropdown
            // (otherwise old item event listeners will keep firing)
            events.$off('roster.item.coords');
        }
    },

    revalidate(items)
    {
        if ( ! items) return;
        
        _.forEach(items, (conflicts, id) =>
        {
            let item = _.find(shared.state.items, { 'id': id });

            // need to use $set to make item reactive
            Vue.set(item, 'conflicts', conflicts);
        });
    },

    checkCarAssignment(item) {
        if (item.duty && item.duty.car && window.$onduro.getConfig('settings.driverAssign') === 'manual') {
            assignDriver(item);
        }
    },

    findAvailableDrivers(rosterItems) {
        return rosterItems.filter(rosterItem => {
            return rosterItem.duty && !rosterItem.duty.car && !rosterItem.isDriver;
        });
    },

    assignDriver(carItem) {
        const availableDrivers = findAvailableDrivers(window.$store.state.roster.items);

        if (availableDrivers.length === 1) {
            setDriver(carItem, availableDrivers[0]);
        } else if (availableDrivers.length > 1) {
            window.$modal.show({
                title: window.$t('Select a Driver'),
                content: availableDrivers.map(driver => ({
                    text: driver.user.name,
                    value: driver
                })),
                confirm: (selectedDriver) => {
                    setDriver(carItem, selectedDriver);
                }
            });
        } else {
            window.$notify.error(window.$t('No available drivers found for this car.'));
        }
    },

    setDriver(carItem, driverItem) {
        carItem.driver = driverItem.id;
        driverItem.isDriver = true;

        window.$http.post('/api/assign-driver', {
            car_id: carItem.id,
            driver_id: driverItem.id
        }).then(() => {
            window.$notify.success(window.$t('Driver assigned successfully.'));
        }).catch(error => {
            console.error(error);
            window.$notify.error(window.$t('Failed to assign driver.'));
        });
    }
}

export default shared;



// WEBPACK FOOTER //
// ./src/js/pages/planning/shared.js